module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor02-2e934ba8bf64ec5f8c8176eff05006fd.png";